import { Avatar, Box, LinearProgress, Rating, Typography } from "@mui/material";
import React from "react";

const Reviews = ({ data }) => {
  const ratingPercentages = [
    { label: "5 Stars", value: data?.rate?.percentage?.percentage_rate_5 },
    { label: "4 Stars", value: data?.rate?.percentage?.percentage_rate_4 },
    { label: "3 Stars", value: data?.rate?.percentage?.percentage_rate_3 },
    { label: "2 Stars", value: data?.rate?.percentage?.percentage_rate_2 },
    { label: "1 Star", value: data?.rate?.percentage?.percentage_rate_1 },
  ];
  return (
    <Box sx={{ padding: "30px" }}>
      <Typography
        sx={{
          fontSize: { xs: "25px", md: "35px" },
          lineHeight: "40px",
          fontWeight: "700",
          marginBottom: "20px",
          textAlign: { xs: "center", sm: "center", md: "start" },
        }}
      >
        Feedback & Reviews
      </Typography>
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          alignItems: "flex-start",
          gap: "60px",
        }}
      >
        <Box
          sx={{
            width: { xs: "100%", md: "50%" },
            display: "flex",
            flexDirection: "column",
            boxShadow: "-4px 4px 4px #00000040",
            border: "1px solid #959595",
            borderRadius: "25px",
            height: "700px",
            overflow: "auto",
            "&::-webkit-scrollbar": {
              width: "6px",
            },
            "&::-webkit-scrollbar-track": {
              background: "#B9B9B9",
              marginLeft: "-10px",
            },
            "&::-webkit-scrollbar-thumb": {
              background: "#3F78E0",
              borderRadius: "10px",
            },
          }}
        >
          {data?.reviews?.length > 0 ? (
            data?.reviews?.map((ele) => (
              <Box
                key={ele.id}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  padding: "30px",
                  gap: "10px",
                  alignItems: { xs: "flex-start", md: "flex-start" },
                  marginBottom: "36px",
                  borderBottom: "1px solid #D9D9D9",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    gap: "10px",
                  }}
                >
                  <Avatar
                    src={ele.user_photo}
                    alt="person"
                    sx={{
                      border: "1px solid #959595",
                      width: "60px",
                      height: "60px",
                    }}
                  />
                  <Box sx={{ display: "flex", flexDirection: "column" }}>
                    <Typography
                      sx={{
                        fontWeight: "500",
                        fontSize: "25px",
                        lineHeight: "30px",
                      }}
                    >
                      {ele.username}
                    </Typography>
                    <Typography
                      sx={{
                        color: "#959595",
                        lineHeight: "25px",
                        fontSize: "20px",
                        fontWeight: "500",
                      }}
                    >
                      {ele.created_at}
                    </Typography>
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    gap: "6px",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: "600",
                      fontSize: "20px",
                      lineHeight: "26px",
                    }}
                  >
                    {ele.subject}
                  </Typography>
                  |
                  <Typography
                    sx={{
                      fontSize: "20px",
                      lineHeight: "26px",
                      color: "#959595",
                      fontWeight: "600",
                    }}
                  >
                    ({ele.rate})
                  </Typography>
                  <Rating
                    value={ele.rate}
                    readOnly
                    sx={{ fontSize: "1.5rem" }}
                  />
                </Box>
                <Box sx={{ marginBottom: "20px" }}>
                  <Typography
                    sx={{
                      fontWeight: "400",
                      fontSize: "20px",
                      lineHeight: "26px",
                      color: "#474747",
                    }}
                  >
                    {ele.description}
                  </Typography>
                </Box>
              </Box>
            ))
          ) : (
            <Typography
              sx={{
                fontSize: "16px",
                lineHeight: "40px",
                fontWeight: "500",
                color: "#494949",
                marginTop: "20px",
              }}
            >
              No reviews yet
            </Typography>
          )}
        </Box>

        <Box sx={{ width: { xs: "100%", md: "50%" } }}>
          {/* Ratings Statistics Header */}
          <Box mb={4}>
            <Typography
              sx={{
                fontWeight: "500",
                color: "#474747",
                fontSize: "28px",
                lineHeight: "35px",
                textAlign: { xs: "center", md: "normal" },
              }}
            >
              Ratings Statistics
            </Typography>
            <Typography
              sx={{
                color: "#959595",
                lineHeight: "30px",
                fontSize: "24px",
                fontWeight: "500",
                marginTop: "10px",
                textAlign: "center",
              }}
            >
              {Number.isFinite(data?.rate?.avg)
                ? data?.rate?.avg.toFixed(2)
                : "0.00"}{" "}
              out of 5.00
            </Typography>
          </Box>

          {/* Display Rating Percentages */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "20px",
              alignItems: "flex-start",
              width: "100%",
            }}
          >
            {ratingPercentages.map((item, index) => (
              <Box
                sx={{ display: "flex", flexDirection: "column", width: "100%" }}
                mb={1}
                key={index}
              >
                <Typography
                  sx={{
                    fontWeight: "500",
                    fontSize: "24px",
                    lineHeight: "30px",
                    color: "#474747",
                  }}
                >
                  {item.label}
                </Typography>
                <Box
                  sx={{ display: "flex", alignItems: "center", width: "100%" }}
                >
                  <Box width="100%" mr={1} ml={1}>
                    <LinearProgress
                      variant="determinate"
                      value={item.value}
                      sx={{
                        "& .MuiLinearProgress-bar": {
                          backgroundColor: "#ECA601", // Color of the filled progress
                        },
                        backgroundColor: "#B9B9B9", // Color of the unfilled track
                        height: 10, // Optional: adjust height if desired
                        borderRadius: "5px", // Optional: rounded corners
                      }}
                    />
                  </Box>

                  <Typography
                    sx={{
                      fontWeight: "600",
                      fontSize: "20px",
                      lineHeight: "25px",
                      color: "#959595",
                    }}
                  >
                    {`${item.value.toFixed(1)}%`}
                  </Typography>
                </Box>
              </Box>
            ))}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Reviews;
